import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    collapseMenu: false,
    label_color_theme: "",
}

const dashboardReducer = createSlice({
    name: "dashboardReducer",
    initialState,
    reducers: {
        setCollapse(state, action){
            state.collapseMenu = action.payload;
        },
        setLabelColorTheme(state, action){
            state.label_color_theme = action.payload
        }
    }
})
export const { setCollapse, setLabelColorTheme } = dashboardReducer.actions;
export default dashboardReducer.reducer;